module.exports = __webpack_public_path__ + "static/media/pic8.8e547b1d.jpg";